<template>
  <div class="new-collision-check h-full overflow-hidden relative">
    <categoryTitle class="mt-10px" title="创建检查" />
    <div class="py-8px flex justify-center item-select-box">
      <el-select
        v-model="subjectNode"
        placeholder="请选择碰撞主体"
        clearable
        class="mr-5px w-4/5"
        size="mini"
        ref="subjectSelect"
        popper-class="visualization-select-popper"
        @clear="handleClearSubject"
        @visible-change="visibleChange"
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          v-model="treeFilterKey"
          size="mini"
          clearable
          @keypress.native.enter="filterModelTree('subject')"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="filterModelTree('subject')"
          ></i>
        </el-input>
        <el-option hidden key="1" :label="subjectNodeName" :value="subjectNode"></el-option>
        <el-tree
          v-if="treeDataLoad"
          class="subjectModelTree max-h-400px mt-5px w-280px overflow-auto"
          :props="treeProps"
          ref="subjectModelTree"
          :data="subjectTreeData"
          :load="loadNode"
          highlight-current
          :lazy="true"
          :filter-node-method="filterNode"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="(data) => clickModelTree(data, 'subject')"
          node-key="node"
        ></el-tree>
      </el-select>
      <el-button type="primary" size="small" @click="selectModel('subject')">选取模型</el-button>
    </div>
    <div class="py-8px flex justify-center item-select-box">
      <el-select
        v-model="objectNode"
        placeholder="请选择碰撞客体"
        clearable
        class="mr-5px w-4/5"
        size="mini"
        ref="objectSelect"
        popper-class="visualization-select-popper"
        @visible-change="visibleChange"
        @clear="handleClearObject"
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          v-model="objectTreeFilterKey"
          size="mini"
          clearable
          @keypress.native.enter="filterModelTree('object')"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="filterModelTree('object')"
          ></i>
        </el-input>
        <el-option hidden key="1" :label="objectNodeName" :value="objectNode"></el-option>
        <el-tree
          v-if="objectTreeDataLoad"
          class="objectModelTree max-h-400px mt-5px w-280px overflow-auto"
          :props="treeProps"
          ref="objectModelTree"
          :data="objectTreeData"
          :load="loadNode"
          highlight-current
          :lazy="true"
          :filter-node-method="filterNode"
          :default-expanded-keys="objectDefaultExpandedKeys"
          @node-click="(data) => clickModelTree(data, 'object')"
          node-key="node"
        ></el-tree>
      </el-select>
      <el-button type="primary" size="small" @click="selectModel('object')">选取模型</el-button>
    </div>
    <div class="py-8px flex justify-center items-center item-select-box">
      <el-radio-group
        class="select-config"
        v-model="collisionType"
        fill="#1099ac"
        @input="handleChangeInput"
      >
        <el-radio :label="0">静态碰撞</el-radio>
        <el-radio :label="1">动态碰撞</el-radio>
      </el-radio-group>
      <el-button
        @click="actionConfig"
        v-if="collisionType === 1 && subjectNode"
        size="small"
        type="primary"
        class="ml-20px"
        >动作配置</el-button
      >
    </div>
    <el-button
      @click="startCheck"
      v-loading="checkBtnLoading"
      size="small"
      type="primary"
      class="ml-20px check-btn"
      >开始检查</el-button
    >
    <categoryTitle class="mt-10px" title="检查结果" />
    <el-table
      :data="tableData"
      :height="`calc(100% - 196px)`"
      highlight-current-row
      row-key="id"
      class="new-collision-table"
      stripe
      v-loading="tableLoading"
      @row-click="rowClick"
    >
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="mainName" label="主体" show-overflow-tooltip></el-table-column>
      <el-table-column prop="guestName" label="客体" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="actionTime"
        label="时间"
        v-if="collisionType === 1"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="{ row }">
          <span @click="resultSave(row)" size="small" class="text-[#44F1FF] cursor-pointer"
            >保存</span
          >
        </template>
      </el-table-column>
      <div slot="empty" class="w-full h-full flex justify-center items-center">
        <span>暂无数据</span>
      </div>
    </el-table>
    <div
      :class="locatingStatus ? 'visible' : 'invisible'"
      class="locating-box transition-all left-140px duration-500 absolute w-65px h-65px top-380px bg-[#00000059] rounded-10px text-[#00e3dd] flex flex-col items-center p-5px"
    >
      <i class="el-icon-loading text-32px"></i>
      <span class="text-14px mt-5px">定位中</span>
    </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { multipleLocations } from './js/publicModelMays'
import EventBus from './js/eventBus'

export default {
  name: 'CollisionCheck',
  components: { categoryTitle },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    modelNode: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collisionMaterialObj: {
      type: Object,
      defalut: {},
    },
    transferProps: {
      type: Object,
      defalut: {},
    },
    transferMode: {
      type: String,
      defalut: '',
    },
  },
  watch: {
    modelNode: {
      async handler(val) {
        if (val && val.node) {
          const nodeInfo = await this.player.Native.Node.getProperty(val.node, ['code', 'name'])
          if (this.transferProps.transferMode === 'walk') {
            this.selectType = 'subject'
            this.subjectNode = val.node
          }
          if (this.selectType === 'subject') {
            this.treeFilterKey = nodeInfo?.name || ''
          } else if (this.selectType === 'object') {
            this.objectTreeFilterKey = nodeInfo?.name || ''
          }
          this.filterModelTree(this.selectType)
          if (this.transferProps.transferMode === 'walk') {
            this.startCheck()
          }
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      locatingStatus: false,
      treeDataLoad: false,
      objectTreeDataLoad: false,
      banLazy: false, // 用于禁止重置目录树数据时，多次触发懒加载
      tableLoading: false,
      checkBtnLoading: false,
      pageNo: 1,
      pageSize: 15,
      total: 0,
      treeData: [], // 模型树数据
      objectTreeData: [],
      subjectTreeData: [],
      previewSubNodePtr: null,
      previewObNodePtr: null,
      subMaterial: null,
      obMaterial: null,
      treeFilterKey: null,
      objectTreeFilterKey: null,
      subjectNode: null,
      subjectNodeName: null,
      objectNode: null,
      objectNodeName: null,
      subjectPhysical: null, // 主体物理
      objectPhysical: null, // 客体物理
      currentNodeInfo: {},
      materialObj: {
        previewSubNodePtr: null,
        previewObNodePtr: null,
        subMaterial: null,
        obMaterial: null,
      },
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
      defaultExpandedKeys: [], // 展开节点
      objectDefaultExpandedKeys: [], // 客体
      tableData: [],
      actionTime: 0,
      collisionType: 0, // 碰撞配置类型
      actions: [], // 动画列表
      playSpeed: 0.5,
      intervalId: null,
      selectType: '',
      showModelTree: false,
      physic: null,
      oldParent: null,
    }
  },
  methods: {
    // 筛选方法
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 定位树节点
    locationNode(item, type) {
      const str = type === 'subject' ? 'subjectModelTree' : 'objectModelTree'
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[str].setCurrentKey(item)
          setTimeout(() => {
            const node = document.getElementsByClassName(str)[0]
            const curNodeArr = document.getElementsByClassName('is-current')
            let currentNode
            if (curNodeArr.length > 1) {
              currentNode =
                type === 'subject'
                  ? document.getElementsByClassName('is-current')[0]
                  : document.getElementsByClassName('is-current')[1]
            } else {
              currentNode = document.getElementsByClassName('is-current')[0]
            }
            window.currentNode = currentNode
            node.scrollTo({
              top: currentNode.offsetTop,
            })
          }, 500)
        }, 500)
      })
    },
    // 模型树点击操作
    clickModelTree(data, type, isSearchStatus = false) {
      const strArr =
        type === 'subject'
          ? ['subjectNode', 'subjectNodeName', 'subjectSelect']
          : ['objectNode', 'objectNodeName', 'objectSelect']
      if (data.node) {
        this[strArr[0]] = data.node
        this[strArr[1]] = data.name
        multipleLocations(this.player, data)
        if (!isSearchStatus) {
          this.$refs[strArr[2]].blur()
        }
      } else {
        this.$message.warning('该节点不存在')
      }
    },
    // 展开节点树
    async expendNode(nodeInfo, type) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      // item: 1为pr模型跟， nodeInfo.parentItem = 0为杆塔模型的跟
      if (nodeInfo.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNodeInfo, type, true)
          this.locationNode(this.currentNodeInfo.node, type)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(nodeInfo.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', nodeInfo.node])
        }
        // 展开
        const expandStr = type === 'subject' ? 'defaultExpandedKeys' : 'objectDefaultExpandedKeys'
        this[expandStr].push(parentInfo.node)
        await this.expendNode(parentInfo, type)
      }
    },
    async filterModelTree(type) {
      const keyword = type === 'subject' ? this.treeFilterKey : this.objectTreeFilterKey
      const treeDataStr = type === 'subject' ? 'subjectTreeData' : 'objectTreeData'
      if (!keyword) {
        setTimeout(() => {
          this[treeDataStr] = this.treeData
        }, 500)
        return
      }
      const startNode = await this.player.Native.Node.getRoot()
      // 过滤模型树
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [keyword],
        codes: [keyword],
      })
      this.currentNodeInfo = res.codes
        ? res.codes[keyword] || {}
        : res.names
          ? res.names[keyword] || {}
          : {}
      // 展开树
      if (!_.isEmpty(this.currentNodeInfo)) {
        await this.expendNode(this.currentNodeInfo, type)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        resolve(this.treeData)
        return
      }
      const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
      const res = result?.children || []
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      resolve(filterRes)
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.treeData = currentProperty.children
      // 删除地球GIS层
      // this.treeData = _.filter(this.treeData, (item) => {
      //   return (
      //     item.itemType === this.modelTreeObj.ITEM_PR ||
      //     item.itemType === this.modelTreeObj.ITEM_NODE
      //   )
      // })
      // console.log('treeData2', this.treeData)
      this.treeDataLoad = true
      this.objectTreeDataLoad = true
    },
    async destroyPhysical() {
      if (this.subjectPhysical && this.objectPhysical) {
        await this.player.Native.PhysicsMgr.destroy(this.subjectPhysical)
        await this.player.Native.PhysicsMgr.destroy(this.objectPhysical)
      }
      if (this.physic && this.oldParent) {
        await this.player.Native.PhysicsMgr.releasePhysicsScene()
        await this.player.Native.PhysicsMgr.setPhysicSceneDynamicPhysic([])
        await this.player.Native.PhysicsMgr.setEnableWalkPhysic(false)
        await this.player.Native.Node.setProperty(this.subjectNode, { parent: this.oldParent })
        await this.player.Native.PhysicsMgr.destroy(this.physic)
      }
      this.physic = null
      this.oldParent = null
      this.subjectPhysical = null
      this.objectPhysical = null
    },
    getCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    actionConfig() {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: { code: 'ActionConfig', origin: 'NewCollisionCheck', name: '步骤配置' },
          position: 'right',
          type: 'tags',
          props: {
            subjectNode: this.subjectNode,
            objectNode: this.objectNode,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    formatSeconds(seconds) {
      const hour = Math.floor(seconds / 3600)
      const minute = Math.floor((seconds % 3600) / 60)
      const second = seconds % 60
      return [hour, minute, second]
        .map((item) => {
          return item.toString().padStart(2, '0')
        })
        .join(':')
    },
    // 开始检查
    async startCheck() {
      if (this.checkBtnLoading) return
      if (!this.subjectNode) {
        this.$message.warning('请选择碰撞主体')
        return
      }
      if (this.collisionType === 1 && this.actionTime <= 0) {
        this.$message.warning('请先进行动作配置')
        return
      }
      await this.destroyPhysical()
      const seletedNodes = await this.player.Native.Node.getSeletedNodes()
      if (seletedNodes.length > 0) {
        await this.player.Native.Node.unSelectNodes(seletedNodes)
      }
      this.tableData.length = 0
      this.tableLoading = true
      this.checkBtnLoading = true
      const subjectNodePtr = this.subjectNode
      const objectNodePtr = this.objectNode
      if (subjectNodePtr && objectNodePtr) {
        const subjectNode = await this.player.Native.Node.getProperty(objectNodePtr, ['parent'])
        const isAncestor1 = subjectNode.parent === subjectNodePtr
        if (isAncestor1) {
          this.objectPhysical = await this.player.Native.PhysicsMgr.create(objectNodePtr, 1)
          this.subjectPhysical = await this.player.Native.PhysicsMgr.create(subjectNodePtr, 0)
        } else {
          this.subjectPhysical = await this.player.Native.PhysicsMgr.create(subjectNodePtr, 1)
          this.objectPhysical = await this.player.Native.PhysicsMgr.create(objectNodePtr, 0)
        }
      } else if (!objectNodePtr) {
        // 设置父节点到根
        const root = await this.player.Native.Node.getRoot()
        const rootChilren = await player.Native.Node.getProperty(root, ['children'])
        const modelNode = rootChilren.children[0].node
        const props = await this.player.Native.Node.getProperty(this.subjectNode, ['parent'])
        this.oldParent = props.parent
        await this.player.Native.Node.setProperty(this.subjectNode, { parent: root })
        // 创建物理场景
        await this.player.Native.PhysicsMgr.setEnableWalkPhysic(true)
        await this.player.Native.PhysicsMgr.updatePhysicScene(modelNode)
        // 创建运动的物理体
        this.physic = await this.player.Native.PhysicsMgr.create(this.subjectNode, 1)
        await this.player.Native.PhysicsMgr.setPhysicSceneDynamicPhysic([this.physic])
      }
      // 静态碰撞
      if (this.collisionType === 0) {
        const collisionRes = await this.player.Native.PhysicsMgr.getCollisionResult()
        if (collisionRes.length <= 0) {
          this.$message.warning('当前主/客体之间无碰撞点')
        } else {
          await this.player.Native.Setting.set('func.collisionTestVisible', true)
          for (const item of collisionRes) {
            // const item = collisionRes[i]
            const posArr = item.contacts[0]?.pA ? item.contacts[0]?.pA : item.contacts[0]?.pB
            // eslint-disable-next-line no-await-in-loop
            const datas = await this.player.Native.Node.getProperty(
              [item.physicA.node, item.physicB.node],
              ['name', 'code']
            )
            const NodeA = item.NodeA ? item.NodeA : datas[0].name
            const NodeB = item.NodeB ? item.NodeB : datas[1].name
            this.tableData.push({
              mainName: item.physicA.mass === true ? NodeA : NodeB,
              guestName: item.physicA.mass === true ? NodeB : NodeA,
              checkTime: this.getCurrentTime(),
              xPosition: posArr[0].toFixed(2).toString(),
              yPosition: posArr[1].toFixed(2).toString(),
              zPosition: posArr[2].toFixed(2).toString(),
            })
          }
        }
        this.tableData = _.uniqBy(this.tableData, ['mainName'], ['guestName'])
      } else {
        // 动态碰撞
        await this.player.Native.AnimationAction.bindActionUpdate(this.aniAction)
        this.player.Native.AnimationAction.EventActionUpdate.connect(this.watchActionUpdate)
        await this.player.Native.AnimationMixer.setTime(this.mixer, 0)
        await this.player.Native.AnimationAction.setLoop(this.aniAction, 0, 1)
        await this.player.Native.AnimationAction.play(this.aniAction)
        await this.player.Native.AnimationAction.setTimeScale(this.aniAction, this.playSpeed)
        this.intervalId = setInterval(async () => {
          const time = await this.player.Native.AnimationMixer.time(this.mixer)
          const collisionRes = await this.player.Native.PhysicsMgr.getCollisionResult()
          if (collisionRes.length > 0) {
            await this.player.Native.Setting.set('func.collisionTestVisible', true)
            for (const item of collisionRes) {
              // const item = collisionRes[i]
              const posArr = item.contacts[0]?.pA ? item.contacts[0]?.pA : item.contacts[0]?.pB
              // eslint-disable-next-line no-await-in-loop
              const datas = await this.player.Native.Node.getProperty(
                [item.physicA.node, item.physicB.node],
                ['name', 'code']
              )
              const NodeA = item.NodeA ? item.NodeA : datas[0].name
              const NodeB = item.NodeB ? item.NodeB : datas[1].name
              const actionTime = this.formatSeconds(Math.trunc(time))
              const isExits = this.tableData.some((item) => {
                return item.actionTime === actionTime
              })
              if (!isExits) {
                this.tableData.push({
                  mainName: item.physicA.mass === true ? NodeA : NodeB,
                  guestName: item.physicA.mass === true ? NodeB : NodeA,
                  checkTime: this.getCurrentTime(),
                  xPosition: posArr[0].toFixed(2).toString(),
                  yPosition: posArr[1].toFixed(2).toString(),
                  zPosition: posArr[2].toFixed(2).toString(),
                  actionTime,
                })
              }
            }
          }
        }, 1000)
      }
      this.tableLoading = false
      this.checkBtnLoading = false
    },
    // 监听节点动画
    async watchActionUpdate(data) {
      if (data && data.sender && data.state === 2) {
        clearInterval(this.intervalId)
        this.intervalId = null
        await this.player.Native.AnimationAction.stop(this.aniAction)
        await this.player.Native.AnimationMixer.applyTime(this.mixer, 0, true)
      }
    },
    // 重置碰撞预览颜色
    async resetNodeMaterial() {
      if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
        await this.player.Native.Node.setProperty([
          {
            node: this.materialObj.previewSubNodePtr,
            props: { colorIndex: 0 },
          },

          {
            node: this.materialObj.previewObNodePtr,
            props: { colorIndex: 0 },
          },
        ])
      }
      this.materialObj = this.$options.data().materialObj
      EventBus.$emit('materialNodeChange', false)
    },
    async rowClick(row) {
      try {
        if (this.locatingStatus) return
        this.locatingStatus = true
        await this.resetNodeMaterial()
        const rootNode = await this.player.Native.Node.getRoot()
        if (rootNode) {
          this.player.Native.Camera.moveToPos(
            [parseFloat(row.xPosition), parseFloat(row.yPosition), parseFloat(row.zPosition)],
            rootNode,
            2,
            1
          )
          this.materialObj.previewSubNodePtr = await this.player.Native.Node.findNodeByName(
            rootNode,
            row.mainName
          )
          this.materialObj.previewObNodePtr = await this.player.Native.Node.findNodeByName(
            rootNode,
            row.guestName
          )
          if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
            await this.player.Native.Node.setProperty([
              { node: this.materialObj.previewSubNodePtr, props: { colorIndex: 32 } },
              { node: this.materialObj.previewObNodePtr, props: { colorIndex: 45 } },
            ])
            EventBus.$emit('materialNodeChange', this.materialObj)
          } else {
            this.$message.warning('未查找到模型节点')
          }
        }
        this.locatingStatus = false
      } catch (error) {
        this.locatingStatus = false
      }
    },
    // 保存检查结果
    async resultSave(row) {
      const filterEvent = new CustomEvent('openCollisionEdit', {
        detail: {
          collisionInfo: { ...row, collisionType: this.collisionType },
          actions: this.actions,
        },
      })
      window.dispatchEvent(filterEvent)
      if (this.aniAction && this.mixer) {
        await this.player.Native.AnimationAction.stop(this.aniAction)
        await this.player.Native.AnimationMixer.applyTime(this.mixer, 0, true)
      }
    },
    materialNodeChange(data) {
      if (!data) {
        this.materialObj = this.$options.data().materialObj
      } else {
        this.materialObj = Object.assign(this.materialObj, data)
      }
    },
    handleChangeInput(e) {
      this.tableData = []
    },
    async selectModel(type) {
      this.selectType = type
      const isOpen = await this.player.Native.OperatingMode.isEnable(1)
      if (!isOpen) {
        await this.player.Native.OperatingMode.enableOperate(1)
      }
    },
    visibleChange(val) {
      if (val) {
        this.locationNode(this.currentNodeInfo.node, this.selectType)
      }
    },
    handleClearSubject(e) {
      this.subjectNodeName = ''
    },
    handleClearObject(e) {
      this.objectNodeName = ''
    },
  },
  beforeDestroy() {
    this.resetNodeMaterial()
    this.destroyPhysical()
    this.player.Native.OperatingMode.disableOperate(1)
    EventBus.$off('listMaterialNodeChange', this.materialNodeChange)
  },
  async created() {
    if (Object.keys(this.transferProps).length > 0) {
      this.collisionType = this.transferProps.collisionType || 0
      this.actions = this.transferProps.actions
      this.subjectNode = this.transferProps.subjectNode
      this.objectNode = this.transferProps.objectNode
      this.aniAction = this.transferProps.aniAction
      this.actionTime = this.transferProps.actionTime || 0
      this.mixer = this.transferProps.mixer
      this.playSpeed = this.transferProps.playSpeed || 0.5
      const datas = await this.player.Native.Node.getProperty(
        [this.subjectNode, this.objectNode],
        ['name', 'code']
      )
      this.subjectNodeName = datas[0].name
      this.objectNodeName = datas[1].name
    }
    await this.getModelTreeDatas()
    this.materialObj = this.collisionMaterialObj
    EventBus.$on('listMaterialNodeChange', this.materialNodeChange)
  },
}
</script>
<style lang="scss" scoped>
.button-bg-img {
  background: url('../../../assets/images/button_blue.png');
  background-size: 100% 100%;
}

.new-collision-check {
  ::v-deep .check-btn {
    height: 36px !important;
    background-color: rgb(67 153 174 / 0.35) !important;
    border: 1px solid #629eaa !important;
    border-radius: 2px !important;
    background-image: none !important;
  }

  ::v-deep .check-btn:hover,
  ::v-deep .check-btn:focus {
    background-image: none !important;
  }

  ::v-deep .el-input__inner {
    background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
    background-size: 100% 100% !important;
    border: none !important;
    border-radius: unset !important;
  }

  .new-collision-table {
    ::v-deep .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: transparent !important;
    }

    ::v-deep .el-table__row.el-table__row--striped {
      background: linear-gradient(0deg, #17c5dc5e, #1de3fd1a);
    }

    ::v-deep .el-table__body .current-row {
      background: linear-gradient(0deg, #986c36, #986c3666);
    }
  }

  .item-select-box {
    ::v-deep .el-input__suffix .el-icon-arrow-up::before {
      display: inline-block;
      width: 10px;
      height: 8px;
      background: url('../../../assets/images/cockpitNew/arrow-down.png') no-repeat;
      background-size: contain;
      content: '';
    }

    .select-config {
      ::v-deep .el-radio__label {
        color: var(--cockpitInputFontColor) !important;
      }

      ::v-deep.el-radio__input.is-checked .el-radio__inner {
        background: #1099ac !important;
        border-color: #1099ac !important;
      }
    }
  }
}

::v-deep {
  // .el-input__inner {
  //   border-color: rgb(0 255 245);
  //   background-color: transparent;
  //   color: #fff !important;
  // }
  .el-tree-node.is-current > .el-tree-node__content,
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    color: #18bdd4 !important;
    background-color: rgba(4, 190, 228, 0.267) !important;
  }

  .el-tree .is-current .el-tree-node__label,
  .el-tree .is-current .ivu-tree-title {
    color: unset !important;
  }

  .el-tree-node__label {
    color: unset !important;
  }

  .el-scrollbar__wrap {
    width: 100% !important;
  }

  .el-tree-node:focus > .el-tree-node__content,
  .el-tree-node__content:hover,
  .el-upload-list__item:hover {
    background-color: rgba(4, 190, 228, 0.267) !important;
  }
  // .el-input__inner:focus {
  //   border-color: #18bdd4 !important;
  //   color: #fff !important;
  // }
  .el-tree-node > .el-tree-node__children {
    overflow: unset !important;
  }

  .el-table__empty-text {
    display: unset !important;
  }

  .el-table__empty-block::before {
    display: none;
  }

  .el-table .cell {
    cursor: default;
  }
}

.el-tree {
  color: #fff;
  background: linear-gradient(180deg, rgba(4, 87, 105, 0.9) 0%, rgba(1, 58, 70, 0.9) 93.96%),
    linear-gradient(0deg, #45f2eb, #45f2eb);
}

::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: #415c7a;
}

::-webkit-scrollbar-thumb {
  background: #16ded4b8;
}
</style>
